import { faArrowRight, faCheck, faEnvelope, faExclamation, faPen, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { useSelector } from "react-redux";
import { maskUC } from "../../infra/utils/maskUC";
import { Tooltip } from "@mui/material";

const StatusSolicitacao = ({ value }) => {
    switch (value) {
        case 0:
            return (
                <Tooltip title="Em digitação" placement="right">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faPen} />
                    </div>
                </Tooltip>
            )
        case 1:
            return (
                <Tooltip title="Aguardando análise" placement="right">
                    <div className="status_aguardando">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                </Tooltip>
            )
        case 2:
            return (
                <Tooltip title="Revisar orçamento" placement="right">
                    <div className="status_revisao">
                        <FontAwesomeIcon icon={faExclamation} />
                    </div>
                </Tooltip>
            )
        case 5:
            return (
                <Tooltip title="Arquivada" placement="right">
                    <div className="status_arquivada">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                </Tooltip>
            )
        default:
            return (
                <Tooltip title="Aprovada" placement="right">
                    <div className="status_homologado">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                </Tooltip>
            )
    }
}

const StatusObraSolicitacao = ({ value, vGoObraPrazo }) => {
    let dataRetorno = vGoObraPrazo?.DataRetorno.split(" ")[0]

    switch (value) {
        case 1:
            return (
                <Tooltip title="Sem necessidade de obra" placement="right">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faX} />
                    </div>
                </Tooltip>
            )
        case 2:
            return (
                <Tooltip title="Aguardando geração da obra" placement="right">
                    <div className="status_aguardando">
                        <FontAwesomeIcon icon={faExclamation} />
                    </div>
                </Tooltip>
            )
        case 3:
            return (
                <Tooltip title={
                    <>
                        Obra em andamento
                        <br />
                        Data prazo de encerramento:
                        {vGoObraPrazo === undefined || dataRetorno === "01/01/1900" || dataRetorno === "01/01/0001"
                            ? " Não definida."
                            : " " + dataRetorno}
                    </>
                } placement="right">
                    <div className="status_aguardando">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </Tooltip>
            )
        default:
            return (
                <Tooltip title="Obra energizada" placement="right">
                    <div className="status_homologado">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                </Tooltip>
            )
    }
}

const RenderPrazoAdequacao = ({ value }) => {
    let dataAtual = new Date();
    let dataPrazoFormatada = parse(value, 'dd/MM/yyyy HH:mm:ss', new Date())

    dataAtual.setHours(0);
    dataAtual.setMinutes(0);
    dataAtual.setSeconds(0);
    dataAtual.setMilliseconds(0);

    const diff = dataPrazoFormatada.getTime() - dataAtual.getTime();
    const diasDiferenca = Math.ceil(diff / (1000 * 60 * 60 * 24));

    dataPrazoFormatada = format(dataPrazoFormatada, 'dd/MM/yyyy', {
        locale: ptBR
    });


    if (diasDiferenca === 0) {
        return (
            <Tooltip title="O prazo de adequação vence hoje. Após a expiração do prazo, o analista de projeto pode arquivar/cancelar o orçamento." placement="right">
                <div>
                    <strong style={{ color: "#ff6e27" }}>{dataPrazoFormatada}</strong>
                </div>
            </Tooltip>
        )
    } else if (diasDiferenca < 0) {
        return (
            <Tooltip title="O prazo de adequação está vencido. Após a expiração do prazo, o analista de projeto pode arquivar/cancelar o orçamento." placement="right">
                <div>
                    <strong style={{ color: "#fa5757" }}>{dataPrazoFormatada}</strong>
                </div>
            </Tooltip>
        )
    } else if (diasDiferenca < 30) {
        return (
            <Tooltip title="O prazo de adequação vence em menos de 30 dias. Após a expiração do prazo, o analista de projeto pode arquivar/cancelar o orçamento." placement="right">
                <div>
                    <strong style={{ color: "#f4b036" }}>{dataPrazoFormatada}</strong>
                </div>
            </Tooltip>
        )
    } else {
        return (
            <Tooltip title="" placement="right">
                <div>
                    <span style={{ color: "#F8F8F8" }}>{dataPrazoFormatada}</span>
                </div>
            </Tooltip>
        )
    }
};

const StatusDocsAprovacao = ({ value }) => {
    const { Situacao, DocumentacaoAprovada } = value;
    const iconeAprovado = (
        <Tooltip title="Aprovado" placement="right">
            <div className="status_homologado" style={{ marginLeft: '23px' }}>
                <FontAwesomeIcon icon={faCheck} />
            </div>
        </Tooltip>
    );
    const iconeReprovado = (
        <Tooltip title="Não aprovado" placement="right">
            <div className="status_cancelado" style={{ marginLeft: '23px' }}>
                <FontAwesomeIcon icon={faX} style={{ marginRight: '2px' }} />
            </div>
        </Tooltip>
    );

    if (Situacao === 0) {
        return (
            <div></div>
        )
    }

    if (Situacao === 1 && DocumentacaoAprovada === 0) {
        return (
            <Tooltip title="Aguardando análise" placement="right">
                <div className="status_revisao" style={{ marginLeft: '23px' }}>
                    <FontAwesomeIcon icon={faExclamation} />
                </div>
            </Tooltip>
        )
    } else if (Situacao === 1 && DocumentacaoAprovada === 1) {
        return iconeAprovado;
    }

    if (Situacao === 2 && DocumentacaoAprovada === 0) {
        return iconeReprovado;
    } else if (Situacao === 2 && DocumentacaoAprovada === 1) {
        return iconeAprovado;
    }

    if (Situacao === 4) {
        return iconeAprovado;
    }

    if (Situacao === 5 && DocumentacaoAprovada === 1) {
        return iconeAprovado;
    } else if (Situacao === 5 && DocumentacaoAprovada === 0) {
        return iconeReprovado;
    }
};

const RendererUnidadeConsumidora = ({ value }) => {
    const uc = useSelector(state => state.uc);

    if (!value) {
        return (
            <Tooltip
                title={
                    <span>
                        Orçamento de conexão com ligação nova.
                        <br />
                        (UC não informada)
                    </span>
                }
                placement="top"
            >
                <div className="status_digitacao">
                    <FontAwesomeIcon icon={faX} />
                </div>
            </Tooltip>
        );
    }

    const valorFormatado = uc?.rn1095
        ? maskUC(String(value))
        : value;

    return (
        <Tooltip title={valorFormatado} placement="bottom">
            <span>{valorFormatado}</span>
        </Tooltip>
    );
};

const columnsSolicitacaoAcesso = [
    {
        field: 'Situacao',
        headerName: 'Situação',
        renderCell: (params) => (
            <StatusSolicitacao value={params.value} />
        )
    },
    { field: 'id', headerName: 'Orç. conexão', flex: 0.4 },
    { field: 'Protocolo', headerName: 'Protocolo', flex: 0.45 },
    {
        field: 'SituacaoObra',
        headerName: 'Situação obra',
        renderCell: (params) => (
            <StatusObraSolicitacao value={params.value} vGoObraPrazo={params.row?.VGoObraPrazo} />
        )
    },
    {
        field: 'Nome', headerName: 'Nome', flex: 1,
        renderCell: (params) => (
            <Tooltip title={params.value} placement="bottom">
                <p>{params.value}</p>
            </Tooltip>
        )
    },
    {
        field: 'CodigoUC', headerName: 'UC', flex: 0.7,
        renderCell: (params) => (
            <RendererUnidadeConsumidora value={params?.row?.CodigoUC} />
        )
    },
    {
        field: 'Inscricao', headerName: 'Inscrição', flex: 0.8,
        renderCell: (params) => {
            if (!params.value) {
                return '';
            }

            if (params?.row?.TipoInscricao === 1) {
                return params.value.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, "$1.$2.$3-$4")
            } else {
                return params.value.replace(/([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})/, '$1.$2.$3/$4-$5')
            }
        }
    },
    {
        field: 'Complemento', headerName: 'Complemento', flex: 1,
        renderCell: (params) => (
            <Tooltip title={params.value} placement="bottom">
                <p>{params.value}</p>
            </Tooltip>
        )
    },
    {
        field: 'DataCadastro', headerName: 'Data de cadastro', flex: 0.5,
        renderCell: (params) => {
            let dataFormatada = parse(params?.row?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            return dataFormatada;
        }
    },
    {
        field: 'PrazoAnalise', headerName: 'Prazo análise', flex: 0.5,
        renderCell: (params) => {
            let dataFormatada = parse(params.value, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            return (dataFormatada.includes("01/01/1900") || dataFormatada.includes("01/01/0001")) ? '' : dataFormatada;
        }
    },
    {
        field: 'TipoGeracao.Descricao', headerName: 'Tipo fonte primária', flex: 1,
        renderCell: (params) => (
            <Tooltip title={params?.row?.TipoGeracao.Descricao} placement="bottom">
                <p>{params?.row?.TipoGeracao.Descricao}</p>
            </Tooltip>
        )
    },
    {
        field: 'PrazoAdequacao', headerName: 'Prazo adequação', flex: 0.5,
        renderCell: (params) => (
            params?.row?.PossuiPrazoAdequacao ? <RenderPrazoAdequacao value={params.value} /> : ''
        )
    },
    {
        field: 'PrazoDocumentacao', headerName: 'Prazo doc.', flex: 0.5,
        renderCell: (params) => {
            let dataFormatada = parse(params?.row?.PrazoDocumentacao, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            const datasPadroesInvalidasRegex = /^(01\/01\/1900|01\/01\/0001|06\/01\/1900)$/;

            if (datasPadroesInvalidasRegex.test(dataFormatada)) {
                return '';
            }

            return dataFormatada;
        }
    },
    {
        field: 'DocumentacaoAprovada ', headerName: 'Doc. aprov.', flex: 0.5,
        renderCell: (params) => (
            <StatusDocsAprovacao style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', }} value={params?.row} />
        )
    }]

export { columnsSolicitacaoAcesso };